import {ContentListProps} from 'presentation/components/StyledCard/types';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {formatText} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';

import {MyAppointmentsEnum} from 'presentation/constants';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {UseOdontoDuplicityBookedCardProps} from './types';

export function useOdontoDuplicityBookedCard({
	scheduledBooking,
}: UseOdontoDuplicityBookedCardProps) {
	const navigate = useNavigate();
	const {userName} = useAccountInformation();
	const {color, variant, iconName} = useBookingTheme({
		flowType: FlowEnum.ODONTO,
	});

	function handleGoToDetails() {
		navigate(
			MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_ODONTO.replace(
				':id',
				scheduledBooking.bookingNumber,
			),
		);
	}

	const CONTENT_LIST: ContentListProps[] = [
		{
			primaryText: formatText(userName),
			iconName: 'account-circle-filled',
		},
		{
			primaryText: formatText(scheduledBooking.providerName),
			secondaryText: formatText(scheduledBooking.specialtyName),
			secondaryTextColor: 'text.secondary',
			iconName: 'medical-services-filled',
		},
		{
			primaryText: formatText(scheduledBooking.clinicName),
			iconName: 'location-on-filled',
		},
	];

	return {
		handleGoToDetails,
		CONTENT_LIST,
		color,
		variant,
		iconName,
	};
}
